import { Grid, Typography, Box } from "@mui/material";
import DateSelector from "./DateSelector";
import { useState } from "react";
import {
  updateLastStatisticDateRange,
  getLastStatisticDateRange,
  getLastStatisticStrategyId,
  getLastStatisticAccountId,
  updateLastStatisticStrategyId,
  updateLastStatisticAccountId
} from "helpers";

import { Account, Strategy } from "features/trading/accounts";
import StockSelectionModal from "./StockSelectionModal";
import AccountSelectionModal from "./AccountSelectionModal";
import { StatisticState } from "helpers/types";
import { useStrategyQuery } from "hooks/useStrategyQuery";
import { useAccountQuery } from "hooks/useAccountQuery";

interface StatisticHeaderProps {
  state: StatisticState;
  onStateChange: (newState: Partial<StatisticState>) => void;
}

const StatisticHeader = ({ state, onStateChange }: StatisticHeaderProps) => {
  const [isStockModalOpen, setIsStockModalOpen] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);

  const { data: stockData, isLoading: isStockLoading, isFetching: isStockFetching, refetch: refetchStock } = useStrategyQuery();
  const { data: accountData, isLoading: isAccountLoading, isFetching: isAccountFetching, refetch: refetchAccount } = useAccountQuery();

  const handleDateChange = (range: [string | null, string | null]) => {
    onStateChange({ dateRange: range });
    updateLastStatisticDateRange(range);
  };

  const handleStockSelect = (strategy: Strategy) => {
    updateLastStatisticStrategyId(strategy.id);
    setIsStockModalOpen(false);
    refetchStock();
  };

  const handleAccountSelect = (account: Account) => {
    updateLastStatisticAccountId(account.id);
    setIsAccountModalOpen(false);
    refetchAccount();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          onClick={() => setIsStockModalOpen(true)}
          sx={{
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            },
            textAlign: 'center'
          }}
        >
          <Typography variant="h6" component="h2">
            {isStockLoading || isStockFetching ? "Loading stock..." : stockData ? `${stockData.name} Optic` : "Select Stock"}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          onClick={() => setIsAccountModalOpen(true)}
          sx={{
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            },
            textAlign: 'right',
          }}
        >
          <Typography variant="h6" component="h2">
            {isAccountLoading || isAccountFetching ? "Loading account..." : accountData ? `${accountData.client__name} - ${accountData.account_number}` : "Select Account"}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <DateSelector
          defaultRange={state.dateRange}
          onDateChange={handleDateChange}
        />
      </Grid>

      <StockSelectionModal
        open={isStockModalOpen}
        onClose={() => setIsStockModalOpen(false)}
        onSelect={handleStockSelect}
      />

      <AccountSelectionModal
        open={isAccountModalOpen}
        onClose={() => setIsAccountModalOpen(false)}
        onSelect={handleAccountSelect}
      />
    </Grid>
  );
};

export default StatisticHeader;
